import React, { useState, useEffect } from "react";
import signOutWarning from "../../../Common/signOutWarning";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { slice1Actions } from "../../../store/reducer";
import Common, { AUTHORIZATION_LEVEL } from "../../../Common/Common";
import DataBase from "../../../dataBase/liquidGuides";
import SettingsDialog from "../../modals/SettingsDialog";
import LoginModal from "../../modals/LoginModal";
import AlertModal from "../../modals/AlertModal";
import MultiSelectModal from "../../modals/MultiSelectModal";
import UserInfoModal from "../../modals/UserInfoModal";
import TravelersDialog from "../../modals/TravelersDialog";
import "./YouPanel.css";
import { APP_VERSION } from "../../../Common/appVersion";


const YouPanel = () => {
  const dispatch = useDispatch();
  const user_info = useSelector((state) => state.user_info);
  const user_info_id = useSelector((state) => state.user_info_id);
  const Authorization = useSelector((state) => state.Authorization);
  const ContentFontZoom = useSelector((state) => state.ContentFontZoom);

  const [settingsShow, setSettingsShow] = useState(false);
  const [editNameShow, setEditNameShow] = useState(false);
  const [loginMode, setLoginMode] = useState("Login");
  const [loginShow, setLoginShow] = useState(false);
  const [alertShow, setAlertShow] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [alertButtons, setAlertButtons] = useState([]);
  const [multiselectShow, setMultiselectShow] = useState(false);
  const [multiselectItems, setMultiselectItems] = useState([]);
  const [multiselectSelectedItems, setMultiselectSelectedItems] = useState([]);
  const [multiselectTitle, setMultiselectTitle] = useState("");
  const [travelersShow, setTravelersShow] = useState(false);

  const isGuest =
    !user_info.uid ||
    user_info.uid === "guest" ||
    Authorization === AUTHORIZATION_LEVEL.GUEST;

  // CommandPalette lives in a sibling component and can't call into this
  // one directly — same window-CustomEvent pattern navigateAndOpenMenu
  // already uses for Places/Map/Schedule's own menus (MobileBottomNavBar.js).
  useEffect(() => {
    const handler = () => setTravelersShow(true);
    window.addEventListener("openTravelersDialog", handler);
    return () => window.removeEventListener("openTravelersDialog", handler);
  }, []);

  const handleSignOut = () => {
    setAlertTitle("Sign Out");
    setAlertMessage("Are you sure you want to sign out?" + signOutWarning());
    setAlertButtons([
      { Title: "Cancel", Method: () => {} },
      { Title: "Sign Out", Method: doSignOut },
    ]);
    setAlertShow(true);
  };

  const doSignOut = (resp) => {
    if (resp !== "Sign Out") return;
    DataBase.Logout((res) => {
      if (res.pass) {
        console.log("doSignOut")
        dispatch(
          slice1Actions.setUserInfo({
            value: {
              distance_unit: "kilometers",
              date_format: "Month first",
              edit_mode: false,
              email: "guest@gmail.com",
              first_name: "guest",
              last_name: "user",
              uid: "guest",
              create_date: "",
              modify_date: "",
              travel_payouts_marker: "",
            },
          })
        );
        dispatch(slice1Actions.setUserInfoId({ value: null }));
      }
    });
  };

  const settingsCallback = (updated_user_info) => {
    if (Authorization === AUTHORIZATION_LEVEL.GUEST) return;
    dispatch(slice1Actions.setUserInfo({ value: updated_user_info }));
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  const handleContentFontZoom = () => {
    let zoomList = [];
    for (let i = 50; i <= 300; i += 10) {
      zoomList.push({ id: i.toString(), label: i.toString(), value: i, name: i.toString() });
    }
    setMultiselectItems(zoomList);
    setMultiselectSelectedItems([
      {
        id: ContentFontZoom.toString(),
        label: ContentFontZoom.toString(),
        value: ContentFontZoom,
        name: ContentFontZoom.toString(),
      },
    ]);
    setMultiselectTitle("Select Zoom");
    setMultiselectShow(true);
  };

  const handleContentFontZoomCallback = (zoom) => {
    dispatch(slice1Actions.setContentFontZoom({ value: zoom[0].value }));
    if (isGuest) return;
    const updated_user_info = { ...user_info, content_font_zoom: zoom[0].value };
    dispatch(slice1Actions.setUserInfo({ value: updated_user_info }));
    DataBase.updateUser(updated_user_info, user_info.uid, () => {});
  };

  const travelers = user_info.travelers || [];
  const travelersCallback = (updatedTravelers) => {
    if (isGuest) return;
    const updated_user_info = { ...user_info, travelers: updatedTravelers };
    dispatch(slice1Actions.setUserInfo({ value: updated_user_info }));
    DataBase.updateUser(updated_user_info, user_info.uid, () => {});
  };

  const travelersSummary = () => {
    if (travelers.length === 0) return "Add passports, visas, and more";
    const expiringSoon = travelers.reduce((count, t) => {
      const docs = t.documents || [];
      return count + docs.filter((d) => Common.getDocumentExpiryStatus(d.expiryDate) !== "ok").length;
    }, 0);
    const travelerCount = `${travelers.length} ${travelers.length === 1 ? "traveler" : "travelers"}`;
    return expiringSoon > 0 ? `${travelerCount} · ${expiringSoon} expiring soon` : travelerCount;
  };

  const Row = ({ label, value }) => (
    <div className="yp-row">
      <span className="yp-row-label">{label}</span>
      <span className="yp-row-value">{value}</span>
    </div>
  );

  const ActionRow = ({ icon, iconDanger, label, subtitle, danger, onClick }) => (
    <div className={`yp-action-row${danger ? " yp-danger" : ""}`} onClick={onClick}>
      <span className={`yp-action-icon${iconDanger ? " yp-icon-danger" : ""}`}>
        <FontAwesomeIcon icon={icon} />
      </span>
      <span className="yp-action-text">
        <span className="yp-action-label">{label}</span>
        {subtitle && <span className="yp-action-subtitle">{subtitle}</span>}
      </span>
      <FontAwesomeIcon icon={solid("chevron-right")} className="yp-chevron" />
    </div>
  );

  return (
    <div className="yp-panel">
      <h1 className="yp-title">You</h1>
      <div className="yp-status">
        <span className={`yp-dot ${isGuest ? "yp-dot-offline" : "yp-dot-online"}`} />
        {isGuest ? "Not signed in" : `Signed in as ${user_info.email}`}
      </div>

      {!isGuest && (
        <>
          <div className="yp-section-header">PROFILE</div>
          <div className="yp-card">
            <Row label="First name" value={user_info.first_name} />
            <div className="yp-divider" />
            <Row label="Last name" value={user_info.last_name} />
            <div className="yp-divider" />
            <Row label="Email" value={user_info.email} />
            <div className="yp-divider" />
            <Row label="User ID" value={user_info.uid} />
            <div className="yp-divider" />
            <ActionRow icon={solid("pen")} label="Edit Name" onClick={() => setEditNameShow(true)} />
          </div>
        </>
      )}

      <div className="yp-section-header">USER SETTINGS</div>
      <div className="yp-card">
        {!isGuest && (
          <>
            <ActionRow
              icon={solid("gear")}
              label="Settings"
              onClick={() => setSettingsShow(true)}
            />
            <div className="yp-divider" />
          </>
        )}
        <ActionRow
          icon={solid("text-height")}
          label="Content Font Zoom"
          subtitle={ContentFontZoom ? `Current: ${ContentFontZoom}%` : "Adjust content text size"}
          onClick={handleContentFontZoom}
        />
      </div>

      {!isGuest && (
        <>
          <div className="yp-section-header">TRAVEL</div>
          <div className="yp-card">
            <ActionRow
              icon={solid("passport")}
              label="Travel Documents"
              subtitle={travelersSummary()}
              onClick={() => setTravelersShow(true)}
            />
          </div>
        </>
      )}

      <div className="yp-section-header">ACCOUNT</div>
      <div className="yp-card">
        {isGuest ? (
          <>
            <ActionRow
              icon={solid("right-to-bracket")}
              label="Sign in"
              onClick={() => { setLoginMode("Login"); setLoginShow(true); }}
            />
            <div className="yp-divider" />
            <ActionRow
              icon={solid("user-plus")}
              label="Register"
              onClick={() => { setLoginMode("Register"); setLoginShow(true); }}
            />
            <div className="yp-divider" />
            <ActionRow
              icon={solid("key")}
              label="Reset Password"
              onClick={() => { setLoginMode("Forgot Password"); setLoginShow(true); }}
            />
          </>
        ) : (
          <>
            <ActionRow
              icon={solid("right-from-bracket")}
              iconDanger
              label="Sign out"
              danger
              onClick={handleSignOut}
            />
            <div className="yp-divider" />
            <ActionRow
              icon={solid("key")}
              label="Reset Password"
              onClick={() => { setLoginMode("Forgot Password"); setLoginShow(true); }}
            />
          </>
        )}
      </div>

      {APP_VERSION ? (
        <div data-testid="app-version" style={{ textAlign: "center", fontSize: 12, color: "#5B6773", padding: "16px 0 8px" }}>Version {APP_VERSION}</div>
      ) : null}

      {editNameShow ? <UserInfoModal show={true} startEditing onHide={() => setEditNameShow(false)} /> : null}
      <SettingsDialog
        show={settingsShow}
        onHide={() => setSettingsShow(false)}
        callback={settingsCallback}
        user_info={user_info}
        user_info_id={user_info_id}
      />
      <MultiSelectModal
        show={multiselectShow}
        onHide={() => setMultiselectShow(false)}
        MultiselectItems={multiselectItems}
        MultiselectSelectedItems={multiselectSelectedItems}
        MultiselectMode="uni"
        MultiselectCallback={handleContentFontZoomCallback}
        MultiselectTitle={multiselectTitle}
        MultiselectSearchText=""
      />
      <LoginModal
        show={loginShow}
        onHide={() => setLoginShow(false)}
        mode={loginMode}
      />
      <TravelersDialog
        show={travelersShow}
        onHide={() => setTravelersShow(false)}
        travelers={travelers}
        onChange={travelersCallback}
        user_info={user_info}
        Authorization={Authorization}
      />
      <AlertModal
        show={alertShow}
        onHide={() => setAlertShow(false)}
        AlertModalTitle={alertTitle}
        AlertModalMessage={alertMessage}
        AlertModalButtons={alertButtons}
      />
    </div>
  );
};

export default YouPanel;
